import {
  SET_PERSON_CATEGORIES,
  SET_PRODUCT_CATEGORIES,
  SET_SERVICE_CATEGORIES,
} from "../../constants/categoryConstants";

const initialState = {
  personCategories: [],
  productCategories: [],
  serviceCategories: [],
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PERSON_CATEGORIES:
      return {
        ...state,
        personCategories: action.categories,
      };
    case SET_PRODUCT_CATEGORIES:
      return {
        ...state,
        productCategories: action.categories,
      };
    case SET_SERVICE_CATEGORIES:
      return {
        ...state,
        serviceCategories: action.categories,
      };
    default:
      return state;
  }
};

export default categoryReducer;
